import React from 'react';
import { Navigate } from 'react-router-dom';
import { Building2, Construction } from 'lucide-react';
import AppHeader from '../components/layout/AppHeader';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import EmptyState from '../components/shared/EmptyState';
import { useBusinessUnit } from '../hooks/useBusinessUnit';

export default function LaunchesDashboardPage() {
  const { availableUnits, isLoading } = useBusinessUnit();

  if (isLoading) {
    return (
      <>
        <AppHeader title="Empreendimentos" icon={Building2} />
        <div className="p-6"><LoadingSpinner /></div>
      </>
    );
  }

  if (!availableUnits || !availableUnits.includes('launches')) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <AppHeader title="Empreendimentos" subtitle="Módulo Órulo · ADR-018" icon={Building2} />
      <div className="p-4 lg:p-6">
        <EmptyState
          icon={Construction}
          message="Bem-vindo ao módulo Empreendimentos."
          hint="Esta área está em construção. Use o menu para navegar entre Deals e Catálogo."
        />
      </div>
    </>
  );
}
